// src/components/ForBusiness.js
import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import './ForBusiness.css';

const ForBusiness = () => {
  return (
    <section className="for-business-section">
      <div className="container">
        <h2 className="section-title">¿Quienes somos?</h2>
        <div className="about-content">
          <div className="about-text">
            <p className="section-subtitle">
              Empresa que nace en el año 2006 y se dedica a la elaboración y distribución de productos congelados de alta calidad. Especializados en:
            </p>
            <ul className="products-list">
              <li><strong>Palos de Queso</strong> - Tradicionales, con bocadillo y arequipe, en tamaños grandes y pequeños</li>
              <li><strong>Panzerottis</strong> - Exquisitos rellenos con sabores como ranchero, hawaiano y arequipe</li>
              <li><strong>Empanadas</strong> - Empanaditas tipo iglesia y empanadas tradicionales</li>
              <li><strong>Pasteles</strong> - Deliciosos pasteles de pollo para eventos y reuniones</li>
            </ul>
            <p className="about-description">
              Nuestros productos son elaborados con ingredientes de primera calidad, garantizando excelente sabor y textura. Perfectos para cafeterías, restaurantes, panaderías y puntos de venta que desean ofrecer opciones gourmet a sus clientes.
            </p>
          </div>
          <div className="about-info">
            <div className="info-card">
              <MapPin size={32} className="info-icon" />
              <h3>Ubicación</h3>
              <p>Cl. 54A #81B - 86</p>
              <p>Ferrini, Medellín</p>
              <p>Antioquia, Colombia</p>
            </div>
            <div className="info-card">
              <Phone size={32} className="info-icon" />
              <h3>Contacto</h3>
              <p><strong>WhatsApp:</strong> 304 388 2058 | 312 272 5211</p>
              <p style={{ marginTop: '10px', fontSize: '0.9rem' }}>Disponible para consultas sobre productos y pedidos</p>
            </div>
            <div className="info-card">
              <Clock size={32} className="info-icon" />
              <h3>Compromiso</h3>
              <p>Calidad y placer a la hora de comer</p>
              <p style={{ marginTop: '10px', fontSize: '0.9rem' }}>Entrega rápida con domicilio disponible en Medellín</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForBusiness;